<template>
  <div class="vr-compose">
    <div class="vr-compose-button">
      <p
        class="create-map"
        :class="{'create-map-disabled' : !materFlag, 'create-map-merge' : mergeFlag}"
        @click="messageDialogShow=true"
      >
        <img v-show="!mergeFlag" src="../../../assets/views/map/create-map.png" />
        {{ buttonMessage }}
      </p>
      <p class="rename" @click="handleRename">
        <img src="../../../assets/views/map/rename.png" />
        重命名地图
      </p>
    </div>
    <h2>母地图</h2>
    <div v-show="!materPreviewShow" class="mater-map" @click="mapListDialogShow = true">
      <img src="../../../assets/views/models/add-file.png" />
    </div>
    <div v-show="materPreviewShow" class="mater-map-selected">
      <div class="mater-map-selected-top">
        <img :src="materPreviewImg" class="mater-map-selected-top--img" />
        <img
          v-show="deleteShow"
          src="../../../assets/views/map/delete.png"
          class="mater-map-selected-top--delete"
          @click="deleteMaterMap"
        />
      </div>
      <p>{{ materPreviewName }}</p>
    </div>
    <hr />
    <h2>子地图</h2>
    <div class="child-list">
      <ul class="mater-map-selected child-list--list">
        <li v-for="(item, index) in childPreviewData" v-show="childListShow">
          <div class="mater-map-selected-top">
            <img :src="item.preview_img" class="mater-map-selected-top--img" />
            <img
              v-show="deleteShow"
              src="../../../assets/views/map/delete.png"
              class="mater-map-selected-top--delete"
              @click="deleteChildMap(item, index)"
            />
          </div>
          <p>{{ item.child_name }}</p>
        </li>
        <li v-show="!mergeFlag" class="mater-map" @click="handleChildDialog">
          <img src="../../../assets/views/models/add-file.png" />
        </li>
      </ul>
    </div>
    <MapListDialog
      v-show="mapListDialogShow"
      @search="MaterMapData"
      @closeMapListDialog="closeMapListDialog"
    >
      <template v-slot:button>
        <p class="affirm" @click="affirmMater">确认母地图</p>
      </template>
      <template v-slot:list>
        <ul class="map-list-dialog-content-table">
          <li
            v-for="(item, index) in tableMaterData"
            :class="{'checked': item.checked, 'disabled': item.disabled}"
          >
            <el-checkbox
              v-model="item.checked"
              :disabled="item.disabled"
              :class="{'disabled': item.disabled}"
              @change="handleChecked(item, index)"
            />
            <p class="map-list-dialog-content-table--address">{{ item.store_name }}</p>
            <p>{{ item.create_time }}</p>
          </li>
        </ul>
      </template>
    </MapListDialog>
    <MapListDialog
      v-show="mapListChildDialogShow"
      @search="MaterMapData"
      @closeMapListDialog="closeMapListChildDialog"
    >
      <template v-slot:button>
        <p class="affirm" @click="affirmChild">确认子地图</p>
      </template>
      <template v-slot:list>
        <ul class="map-list-dialog-content-table">
          <li
            v-for="(item, index) in tableChildData"
            :class="{'checked': item.checked, 'disabled': item.disabled}"
          >
            <el-checkbox
              v-model="item.checked"
              :disabled="item.disabled"
              :class="{'disabled': item.disabled}"
              @change="handleCheckedChild(item, index)"
            />
            <p class="map-list-dialog-content-table--address">{{ item.store_name }}</p>
            <p>{{ item.create_time }}</p>
          </li>
        </ul>
      </template>
    </MapListDialog>
    <addMapDialog
      v-show="addMapDialogShow"
      @closeDialog="addMapDialogShow=false"
      ref="addMap"
      @newMap="renameMap"
    >
      <template v-slot:header>
        <header>地图重命名</header>
      </template>
      <template v-slot:content>
        <input v-model="inputValue" type="text" />
      </template>
    </addMapDialog>
    <addMapDialog
      v-show="messageDialogShow"
      ref="rename"
      @newMap="createMap(1)"
      @closeDialog="messageDialogShow=false"
    >
      <template v-slot:header>
        <img src="../../../assets/views/map/warning.png" class="message-icon" />
      </template>
      <template v-slot:content>
        <div class="message">请确认地图选择正确且完整合并开始后将无法更新或取消</div>
      </template>
    </addMapDialog>
  </div>
</template>

<script>
import axios from "axios";
import remove from "@/lib/array-remove.js";
import MapListDialog from "@/components/editor/map-list-dialog.vue";
import addMapDialog from "@/components/editor/add-map-dialog.vue";

export default {
  components: {
    MapListDialog,
    addMapDialog
  },
  data() {
    return {
      // 地图列表弹框显示
      mapListDialogShow: false,
      // 重命名地图弹框显示
      addMapDialogShow: false,
      // 重命名名字
      inputValue: "",
      // 合并地图提示弹框显示
      messageDialogShow: false,
      mapListChildDialogShow: false,
      httpAxios: axios.create({}),
      tableMaterData: "",
      tableChildData: "",
      checkedIndex: 0,
      flag: false,
      childHandleArray: [],
      childHandleArrayCopy: [],
      tableChildDataCopy: [],
      materStoreId: "",
      childStoreIds: [],
      childStoreIdsCopy: [],
      materPreviewImg: "",
      materPreviewShow: false,
      materPreviewName: "",
      childPreviewData: [],
      childListShow: false,
      deleteShow: true,
      // 母地图是否确认成功
      materFlag: false,
      childFlag: false,
      buttonMessage: "生成地图",
      mergeFlag: false,
      searchValue: ""
    };
  },
  mounted() {
    console.log("this.$route.query.store_id");
    console.log(this.$route.query.store_id);
    this.$refs.rename.buttonDisabled = false;
    if (!this.$route.query.store_id) return;
    this.$store.commit("getStoreId", this.$route.query.store_id);
    if (
      this.$route.query.store_id !== "create" ||
      this.$store.state.childStoreId
    ) {
      this.createMap();
    }
  },
  created() {
    this.MaterMapData();
  },
  methods: {
    handleRename() {
      this.addMapDialogShow = true;
    },
    closeMapListChildDialog() {
      this.mapListChildDialogShow = false;
    },
    // 点击母地图
    async MaterMapData(val) {
      if (val) this.searchValue = val;
      const params = {
        pattern: this.searchValue
      };
      try {
        const { data } = await await this.$http.post(
          "/navigation/store",
          params
        );
        if (data.retcode === 0) {
          data.data.map(item => {
            item.checked = false;
            item.disabled = false;
          });
          this.tableMaterData = JSON.parse(JSON.stringify(data.data));
          this.tableChildData = JSON.parse(JSON.stringify(data.data));
          this.searchValue = "";
          if (this.materStoreId) {
            this.tableChildData.forEach(item => {
              if (item.store_id === this.materStoreId) {
                item.checked = true;
                item.disabled = true;
              }
            });
          }
        }
      } catch (error) {
        this.$log(error.error_msg);
      }
    },
    handleChecked(item, index) {
      this.tableMaterData.forEach((item, idx) => {
        item.checked = false;
        if (idx === index) {
          item.checked = true;
        }
      });
      this.checkedIndex = index;
      this.materStoreId = item.store_id;
    },
    // 确认母地图
    async affirmMater() {
      this.mapListDialogShow = false;
      const params = {
        map_id: this.$route.params.mapId,
        store_id: this.materStoreId
      };
      try {
        const { data } = await await this.$http.post(
          "/navigation/parent",
          params
        );
        if (data.retcode === 0) {
          this.materPreviewShow = true;
          this.materPreviewImg = data.data.preview_img;
          this.materPreviewName = data.data.store_name;
          this.materFlag = true;
          this.$store.commit("getStoreId", data.data.store_id);
          this.$store.commit("getMergeFlag", "false");
          this.$store.commit("getMaterFlag", "true");
        }
      } catch (error) {
        this.$log(error);
      }
      this.flag = true;
      this.tableMaterData.forEach((item, index) => {
        this.childHandleArray.forEach(i => {
          if (index === i) {
            item.disabled = true;
          }
        });
      });
      this.tableChildData.forEach(item => {
        item.checked = false;
        item.disabled = false;
      });
      if (this.childHandleArray.length) {
        this.tableChildData.forEach((item, index) => {
          this.childHandleArray.forEach(i => {
            if (index === i) {
              item.checked = true;
            }
          });
        });
      }
      this.tableChildData.forEach(item => {
        if (item.store_id === this.materStoreId) {
          item.checked = true;
          item.disabled = true;
        }
      });
    },
    // 取消母地图
    closeMapListDialog() {
      this.mapListDialogShow = false;
      this.tableMaterData.forEach(item => {
        item.checked = false;
      });
      if (!this.flag) return;
      this.tableMaterData[this.checkedIndex].checked = true;
    },
    handleCheckedChild(item, index) {
      this.childHandleArray = Array.from(new Set(this.childHandleArray));
      this.childStoreIds = Array.from(new Set(this.childStoreIds));
      item.checked
        ? this.childHandleArray.push(index)
        : this.childHandleArray.remove(index);
      item.checked
        ? this.childStoreIds.push(item.store_id)
        : this.childStoreIds.remove(item.store_id);
    },
    // 确认子地图
    async affirmChild() {
      this.mapListChildDialogShow = false;
      this.childHandleArrayCopy = JSON.parse(
        JSON.stringify(this.childHandleArray)
      );
      this.childStoreIdsCopy = JSON.parse(JSON.stringify(this.childStoreIds));
      const params = {
        map_id: this.$route.params.mapId,
        store_ids: this.childStoreIdsCopy
      };
      try {
        const { data } = await await this.$http.post(
          "/navigation/children",
          params
        );
        if (data.retcode === 0) {
          this.childListShow = true;
          this.childFlag = true;
          this.childPreviewData = [];
          data.data.forEach(item => {
            this.childPreviewData.push({
              // child_store_id: item.child_store_id,
              store_id: item.store_id,
              preview_img: item.preview_img,
              child_name: item.store_name
            });
          });
          this.$store.commit("getChildStoreId", true);
          this.$store.commit("getChildFlag", "true");
        }
      } catch (error) {
        this.$log(error);
      }
      this.tableMaterData.forEach((item, index, arr) => {
        item.disabled = false;
        item.checked = false;
        this.childStoreIds.forEach(i => {
          if (item.store_id === i) {
            item.disabled = true;
          }
          if (this.flag) {
            // arr[this.checkedIndex].checked = true;
            arr.forEach(item => {
              if (item.store_id === this.materStoreId) {
                item.checked = true;
              }
            });
          }
        });
      });
      this.tableChildData.forEach(item => {
        this.childStoreIds.forEach(i => {
          if (item.store_id === i) {
            item.disabled = true;
            item.checked = true;
          }
        });
      });
    },
    // 取消子地图
    closeMapListChildDialog() {
      this.mapListChildDialogShow = false;
      this.tableChildData = this.tableChildDataCopy;
      this.childHandleArray = JSON.parse(
        JSON.stringify(this.childHandleArrayCopy)
      );
      this.childStoreIds = JSON.parse(JSON.stringify(this.childStoreIdsCopy));
    },
    handleChildDialog() {
      // this.MaterMapData();
      // this.affirmMater();
      this.mapListChildDialogShow = true;
      this.tableChildDataCopy = JSON.parse(JSON.stringify(this.tableChildData));
    },

    // 生成地图
    async createMap(value) {
      console.log("value" + value);
      if (value == 1) this.$store.commit("getMergeFlag", "true");
      if (value == 1) this.buttonMessage = "地图合并中...";
      try {
        if (value == 1) {
          console.log('123')
          await await this.$http.post(
            '/navigation/merge',
            { map_id: this.$route.params.mapId }
          ).then((res) => {
            console.log(res.data.retcode)
            if (res.data.retcode !== 0) return;
          });
        }
        const { data } = await await this.$http.post("/navigation/map", {
          map_id: this.$route.params.mapId
        });
        if (data.retcode === 0) {
          this.deleteShow = false;
          this.messageDialogShow = false;
          this.buttonMessage = "地图已合并";
          this.mergeFlag = true;
          this.$store.commit("mergeFlag", "true");
          this.materPreviewShow = true;
          this.materPreviewImg = data.data.parent_preview_img;
          this.materPreviewName = data.data.parent_name;
          this.childPreviewData = [];
          this.$store.commit("getStoreId", data.data.parent_store_id);
          // console.log(data.data);

          data.data.children_maps.forEach(item => {
            this.childPreviewData.push({
              preview_img: item.child_preview_img,
              child_name: item.child_name,
              // child_store_id: item.child_store_id
              // store_id: item.store_id
              store_id: item.child_store_id
            });
          });
          this.childListShow = true;
          //地图已合并，才可以进行下一步
          this.mergeFlag = data.data.is_merged;
          this.$store.commit("mergeFlag", this.mergeFlag);

          if (this.$store.state.mergeFlag === "true") return;
          if (this.$store.state.childFlag === "true") {
            this.deleteShow = true;
            this.materPreviewShow = false;
            this.mergeFlag = false;
            this.childFlag = true;
            this.buttonMessage = "生成地图";
          }
          if (this.$store.state.materFlag === "true") {
            this.materPreviewShow = true;
            this.materFlag = true;
            this.mergeFlag = false;
            this.deleteShow = true;
            this.buttonMessage = "生成地图";
          }
        }
      } catch (error) {
        this.$log(error);
      }
    },
    // 删除母地图
    deleteMaterMap() {
      this.materPreviewImg = "";
      this.materPreviewShow = false;
      this.materFlag = false;
      this.tableChildData.forEach(item => {
        if (item.store_id === this.materStoreId) {
          item.checked = false;
          item.disabled = false;
        }
      });
      this.tableMaterData.forEach(item => {
        if (item.store_id === this.materStoreId) {
          item.checked = false;
        }
      });
      this.materStoreId = "";
      this.$store.commit("getStoreId", "create");
      this.$store.commit("getMaterFlag", "false");
    },
    // 删除子地图
    async deleteChildMap(value, index) {
      console.log(value);
      const params = {
        map_id: this.$route.params.mapId,
        // store_ids: value.child_store_id
        store_ids: value.store_id
      };
      console.log(params);
      try {
        const { data } = await await this.$http.post(
          "/navigation/children/delete",
          params
        );
        console.log("data.retcode");
        if (data.retcode === 0) {
          this.tableMaterData.forEach(item => {
            if (item.store_id === value.store_id) {
              item.disabled = false;
            }
          });
          this.tableChildData.forEach(item => {
            if (item.store_id === value.store_id) {
              item.disabled = false;
              item.checked = false;
            }
          });
          this.childPreviewData.splice(index, 1);
          this.childHandleArray.splice(
            this.childStoreIds.indexOf(value.store_id),
            1
          );
          this.childHandleArrayCopy.splice(
            this.childStoreIds.indexOf(value.store_id),
            1
          );
          this.childStoreIds.remove(value.store_id);
          this.childStoreIdsCopy.remove(value.store_id);
        } else {
          this.$message("删除失败");
        }
      } catch (error) {
        this.$message("删除失败");
        this.$log(error);
      }
    },
    // 地图重名名
    async renameMap() {
      if (!this.inputValue) return;
      this.addMapDialogShow = false;
      const params = {
        map_id: this.$route.params.mapId,
        map_name: this.inputValue
      };
      try {
        const { data } = await await this.$http.post(
          "/navigation/rename",
          params
        );
        this.inputValue = "";
      } catch (error) {
        this.$log(error);
      }
    }
  },
  watch: {
    inputValue(val) {
      if (!val) {
        this.$refs.addMap.buttonDisabled = true;
      } else {
        this.$refs.addMap.buttonDisabled = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.vr-compose {
  width: 100%;
  min-height: 100%;
  background-color: rgb(30, 30, 30);
  padding: 20px 40px;
  .vr-compose-button {
    display: flex;
    p {
      width: 180px;
      text-align: center;
      font-size: 16px;
      color: #adadad;
      border: 1px solid #adadad;
      border-radius: 4px;
      padding: 10px 0;
      margin-right: 30px;
      img {
        vertical-align: top;
      }
    }
    .create-map {
      border-color: #08ce82;
      color: #08ce82;
    }
    .create-map-disabled {
      opacity: 0.5;
      pointer-events: none;
    }
    .create-map-merge {
      background-color: #08ce82;
      color: #ffffff;
      pointer-events: none;
    }
  }
  h2 {
    font-size: 26px;
    color: #ffffff;
    line-height: 37px;
    font-weight: 400;
  }
  .mater-map {
    width: 180px;
    height: 150px;
    border: 2px dashed #979797;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;
    img {
      width: 19px;
      height: 19px;
    }
  }
  .child-list {
    display: flex;
    &--list {
      padding: 0;
      margin: 0;
      list-style: none;
      display: flex;
      flex-wrap: wrap;
    }
  }
  .mater-map-selected {
    &-top {
      display: flex;
      align-items: flex-end;
      margin-right: 66px;
      &--img {
        width: 180px;
        height: 150px;
        border-radius: 9px;
        margin-right: 10px;
      }
      &--delete {
        width: 24px;
        height: 24px;
      }
    }
    p {
      font-size: 16px;
      color: #ffffff;
      margin-top: 10px;
    }
  }
  hr {
    margin: 0;
    border: none;
    border-top: 1px solid #979797;
  }
}
</style>
